import ScrollWatcher from '../util/ScrollWatcher';
import ScrollInto from '../util/ScrollInto';

export default {
	init() {
	// JavaScript to be fired on all pages

	// Setup scrollwatcher to handle "special" menu
    if( !document.body.classList.contains('force-header') ) {
        const scrollLimit = 40;
        let scrolled = document.body.classList.contains('scrolled');
        new ScrollWatcher(yPos => {

            if( yPos > scrollLimit && !scrolled ) {
    
                scrolled = true;
                document.body.classList.add('scrolled');
    
            }else if( yPos < scrollLimit && scrolled ) {
    
                scrolled = false;
                document.body.classList.remove('scrolled');
    
            }
        });
    }
	
	// Setup scrollinto for certain classes
	const ScrollIntoClassNames = [
	'.wp-block-maritech-image__toptext',
	'.wp-block-maritech-image__text',
	'.wp-block-maritech-image-dynamic__toptext',
	'.wp-block-maritech-image-dynamic__text',
	'.wp-block-maritech-video__text',
	'.wp-block-maritech-video__toptext',
	'.wp-block-maritech-case__toptext',
	'.title',
	'.featuredtext',
	'.wp-block-maritech-event',
	'.wp-block-maritech-text',
	'.wp-block-maritech-sidebar',
	'.sidebarmenu',
	];
	new ScrollInto(ScrollIntoClassNames.join(', '), (el) => {
		el.className += ' in-view';
	});
/*
	function animate_svg(svg) {
		let circle = svg.querySelector('circle');
		let radius = 54;
		let circumference = radius * 2 * Math.PI;
		circle.style.strokeDasharray = `${circumference} ${circumference}`;
		circle.style.strokeDashoffset = `${circumference}`;
		let startTime = performance.now();
		const duration = 300;
		const interval = setInterval(() => {
			const now = performance.now();
			const percent = Math.min(1, (now-startTime)/duration);
			const offset = circumference - percent / 100 * circumference;
			circle.style.strokeDashoffset = offset;
			if((now - startTime) > duration){
				clearInterval(interval);
			}

		}, 25)
	}

	new ScrollInto('.wp-block-maritech-image__toptext', (el) => {
		el.className += ' in-view hasring';
		let svg = document.createElement('svg');
		svg.className='wp-block-maritech-image__toptext__ring';
		svg.setAttribute('width', 120);
		svg.setAttribute('height',120);
		svg.innerHTML = '<circle class="wp-block-maritech-image__toptext__ring__circle" stroke="white" stroke-width="4" fill="transparent" r="52" cx="60" cy="60"/>';
		el.appendChild(svg);

		animate_svg(svg);
	});*/

	const ScrollIntoFastClassNames = [
	'.wp-block-maritech-text__inner',
	];
	new ScrollInto(ScrollIntoFastClassNames.join(', '), (el) => {
		el.className += ' in-view';
	});

	const allClassNames = ScrollIntoClassNames.concat(ScrollIntoFastClassNames);
	
	let last_known_scroll_position = 0;
	let ticking = false;

	function check_if_at_bottom(pos){
		if((window.innerHeight + pos) >= document.body.offsetHeight) {
			// Scrolled to bottom
			const els = document.querySelectorAll(allClassNames.join(', '));
			for (var i = els.length - 1; i >= 0; i--) {
				els[i].classList.add('in-view');
			}
		}
	}

	window.addEventListener('scroll', () => {
		last_known_scroll_position = window.scrollY;

		if (!ticking) {
			window.requestAnimationFrame(function() {
				check_if_at_bottom(last_known_scroll_position);
				ticking = false;
			});

			ticking = true;
		}
	});


	/**
	 * Video buttons
	 */
	const videos = document.querySelectorAll('.wp-block-maritech-video__video');
	if( videos ) {
		videos.forEach(video => {
			const videoEl = video.querySelector('video');
			const pauseEl = video.querySelector('.video__button--pause');
			const muteEl  = video.querySelector('.video__button--mute');

			if ( videoEl && pauseEl ) {
				pauseEl.addEventListener('click', evt => {
					evt.preventDefault();
					if( videoEl.paused ) {
						videoEl.play();
						video.classList.remove( 'video--paused' );
					} else {
						videoEl.pause();
						video.classList.add( 'video--paused' );
					}
				});
			}

			if ( videoEl && muteEl ) {
				muteEl.addEventListener( 'click', event => {
					event.preventDefault();
					if ( videoEl.muted ) {
						videoEl.muted = false;
						video.classList.remove( 'video--muted' );
					} else {
						videoEl.muted = true;
						video.classList.add( 'video--muted' );
					}
				});
			}
		})
	}

	/**
	 * Accordion
	 */
	const accordions = document.querySelectorAll('.wp-block-maritech-accordion-inner');
	if(accordions && accordions.length > 0) {
		accordions.forEach(accordion => {
			const toggler = accordion.querySelector('.wp-block-maritech-accordion-inner__title'); 
			if( toggler ) {
				toggler.addEventListener('click', () => {
					accordion.classList.toggle('open-accordion');
				});
			}
		})
	}
},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js